import Role from 'models/core/role/Model.Role';
import Model from 'models/Model';
import contractRefundPaymentEmailTemplateDeleteApi from './delete/Api.ContractRefundPaymentEmailTemplate.Delete';
import contractRefundPaymentEmailTemplateListApi from './list/Api.ContractRefundPaymentEmailTemplate.List';
import contractRefundPaymentEmailTemplateSaveApi from './save/Api.ContractRefundPaymentEmailTemplate.Save';

export default class ContractRefundPaymentEmailTemplate
  extends Model<Model.IContractRefundPaymentEmailTemplate>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IContractRefundPaymentEmailTemplate>
{
  id: number;
  name: string;
  contractRefundPaymentStatusTrigger: Model.Enum.ContractRefundPaymentStatusTriggers;
  senderEmail: string;
  senderName: string;
  subject: string;
  htmlBody: string;
  recipientsWithRole?: Role[];

  sendToRemittanceEmail: boolean = false;
  sendToOwner: boolean = false;
  additionalRecipientEmails: string[] = [];

  languageIsoCode?: Locale.Languages;
  readonly baseEntityId: number;

  constructor(
    data:
      | Partial<Model.IContractRefundPaymentEmailTemplate>
      | Utils.FormData<Model.IContractRefundPaymentEmailTemplate>,
    language?: Locale.Languages
  ) {
    super(
      {
        recipientsWithRole: [Role],
      },
      language
    );
    this.update(data);
    if (!this.additionalRecipientEmails) this.additionalRecipientEmails = [];
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.name,
      info: this.senderName,
      subtitle: this.senderEmail,
    };
  }
  static async list(body?: Api.Core.ContractRefundPaymentEmailTemplate.List.IRequest) {
    const { payload, ...rest } = await contractRefundPaymentEmailTemplateListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ContractRefundPaymentEmailTemplate(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await contractRefundPaymentEmailTemplateSaveApi(this);
  }
  async delete() {
    return await contractRefundPaymentEmailTemplateDeleteApi(this.id);
  }
}
